import type { ReactNode } from 'react'

import styles from './Section.module.css'

type SectionProps = {
  id: string
  /** Small mono label above the heading. */
  eyebrow: string
  title: string
  /** Optional lead paragraph under the heading. */
  lead?: string
  children: ReactNode
}

/**
 * Every content section shares this shell so headings, spacing, and the
 * heading/landmark relationship stay consistent.
 */
export function Section({ id, eyebrow, title, lead, children }: SectionProps) {
  const headingId = `${id}-heading`

  return (
    <section id={id} className={styles.section} aria-labelledby={headingId}>
      <div className="container">
        <header className={styles.head}>
          <p className="eyebrow">{eyebrow}</p>
          <h2 id={headingId} className={styles.title}>
            {title}
          </h2>
          {lead && <p className={styles.lead}>{lead}</p>}
        </header>
        {children}
      </div>
    </section>
  )
}
